<div class="under-development-container">
  <div class="content">
    <div class="illustration">
      <img src="assets/images/under-construction.png" alt="Under Development" />
    </div>
    <h1>Dashboard is currently under development and will be available soon.</h1>
  </div>
</div>
